
import { useLocation, useNavigate } from "react-router-dom";
import PartnerSummaryStep from "./steps/partnerSummaryStep";
import PartnerUserStep from "./steps/partnerUserStep";
import PartnerProductStep from "./steps/partnerProductStep";
import PartnerCheckoutStep from "./steps/partnerCheckoutStep";
import PartnerStatusStep from "./steps/partnerStatusStep";
import PartnerCommentsStep from "./steps/partnerCommentsStep";
import { useEffect, useState } from "react";
import UncontrollableAccordion from "../../../atoms/uncontrollableAccordion";
import { cashnator, cpfMask, phoneMask } from "../../../utils/functions";
import { getGradingTypeLabel, getPreLacreFormatLabel, normalizeGradingType, priorityTypes } from "../../../utils/gradingTypes";
import { statusObject } from "../../../utils/allProductStatus";

const CreatePartnerProduct = ({ user }) => {
    
    const location = useLocation();
    const navigate = useNavigate();

    const [step, setStep] = useState(0);
    const [userData, setUserData] = useState({});
    const [deliveryData, setDeliveryData] = useState({delivery: "presencial", store: user?.store?._id});
    const [productData, setProductData] = useState({});

    useEffect(() => {
        if (location?.state?.origin === "users-new") {
            setUserData(location?.state?.user);
            setStep(1);
        }
        // eslint-disable-next-line
    }, [])


    const refresh = (id) => {
        navigate(`/partner/products/${id}`);
    }

    // Sem loja na sessão o pedido nasceria sem `store` e sumiria do hub
    // (incidente 2026-09-24). O backend também recusa; aqui evitamos o fluxo inteiro.
    if (!user?.store) {
        return (
            <main className="text-center px-2">
                <h1 className="border-b border-primary text-center text-lg font-bold mb-2">Criação de Pedido</h1>
                <p className="mt-4">Você não possui um reino parceiro</p>
                <p className="mt-2 text-sm">Se a loja acabou de ser atribuída, atualize a página ou saia e entre novamente.</p>
            </main>
        )
    }

    if (step === 5) {
        return (
            <main className="text-center px-2 mb-10">
                <h1 className="border-b border-primary text-center text-lg font-bold mb-2">Criação de Pedido</h1>
                <PartnerSummaryStep stores={null} user={user} productData={productData} deliveryData={deliveryData} setStep={setStep} refresh={refresh} userData={userData} />
            </main>
        )
    }
    return (
 <main className="text-center px-2">
    {/* <button onClick={() => console.log(deliveryData)}>depurate</button> */}
            <h1 className="border-b border-primary text-center text-lg font-bold mb-2">Criação de Pedido</h1>
            {
                step === 0 ?
                    <UncontrollableAccordion title="Usuário" show={step === 0}>
                        <PartnerUserStep user={user} setUserData={setUserData} setStep={setStep} />
                    </UncontrollableAccordion>
                    :
                    <div className="mb-4 border border-primary bg-[#ffffff11] p-2">
                        <h3 className="mb-2 text-lg font-bold">Usuário</h3>
                        <div className="flex w-fit m-auto gap-4">
                            <p className="">Nome:</p>
                            <p className="">{userData?.name}</p>
                        </div>
                        <div className="flex m-auto w-fit gap-4">
                            <p className="flex-1">Email:</p>
                            <p className="flex-1">{userData?.email}</p>
                        </div>
                        <div className="flex m-auto w-fit gap-4">
                            <p className="">Telefone:</p>
                            <p className="">{phoneMask(userData?.phone)}</p>
                        </div>
                        <div className="flex m-auto w-fit gap-4">
                            <p className="">{userData?.documentType === "other" ? "Documento" : userData?.documentType}:</p>
                            <p className="">{userData?.documentType === "other" ? userData?.documentNumber : cpfMask(userData?.documentNumber)}</p>
                        </div>
                    </div>
            }

            {
                step <= 1 ?
                    <UncontrollableAccordion title="Dados do pedido" show={step === 1} done={step > 1}>
                        <PartnerProductStep setStep={setStep} deliveryData={deliveryData} setProductData={setProductData} productData={productData} />
                    </UncontrollableAccordion>
                    : step > 1 ?
                        <div className="mb-4 border border-primary bg-[#ffffff11] p-2">
                            <h3 className="mb-2 text-lg font-bold">Pedido</h3>
                            <div className="flex w-fit m-auto gap-4">
                                <p className="">Tipo:</p>
                                <p className="">{getGradingTypeLabel(productData?.gradingType)}</p>
                            </div>
                            <div className="flex w-fit m-auto gap-4">
                                <p className="">Autógrafo:</p>
                                <p className="">{productData?.autographEvaluation ? "Sim" : "Não"}</p>
                            </div>
                            {
                                normalizeGradingType(productData?.gradingType) === "pre" && productData?.preLacreFormat ?
                                    <div className="flex w-fit m-auto gap-4">
                                        <p className="">Pré lacre:</p>
                                        <p className="">{getPreLacreFormatLabel(productData?.preLacreFormat)}</p>
                                    </div>
                                    : null
                            }
                            <div className="flex w-fit m-auto gap-4">
                                <p className="">Nº itens:</p>
                                <p className="">{productData?.numberOfCards}</p>
                            </div>
                            <div className="flex w-fit m-auto gap-4">
                                <p className="">Prioridade:</p>
                                <p className="">{priorityTypes[productData?.priority]}</p>
                            </div>
                            <div className="flex w-fit m-auto gap-4">
                                <p className="">Valor declarado:</p>
                                <p className="">{cashnator(productData?.declaredValue)}</p>
                            </div>
                        </div>
                        : null
            }

            {
                step <= 2 ?
                    <UncontrollableAccordion title="Dados calculados" show={step === 2} done={step > 2}>
                        <PartnerCheckoutStep user={user} productData={productData} deliveryData={deliveryData} setDeliveryData={setDeliveryData} setStep={setStep} setProductData={setProductData} />
                    </UncontrollableAccordion>
                    : step > 2 ?
                        <div className="mb-4 border border-primary bg-[#ffffff11] p-2">
                            <h3 className="mb-2 text-lg font-bold">Dados calculados</h3>
                            <div className="flex w-fit m-auto gap-4">
                                <p className="">Taxa de manuseio:</p>
                                <p className="">{cashnator(productData?.insurance)}</p>
                            </div>
                            <div className="flex w-fit m-auto gap-4">
                                <p className="">Valor final:</p>
                                <p className="">{cashnator(productData?.finalPrice)}</p>
                            </div>

                        </div>
                        : null
            }

            {
                step <= 3 ?
                    <UncontrollableAccordion title="Status" show={step === 3} done={step > 3}>
                        <PartnerStatusStep setProductData={setProductData} setStep={setStep} productData={productData} />
                    </UncontrollableAccordion>
                    : step > 3 ?
                        <div className="mb-4 border border-primary bg-[#ffffff11] p-2">
                            <h3 className="mb-2 text-lg font-bold">Status</h3>
                            <div className="flex w-fit m-auto gap-4">
                                <p className="">{statusObject[productData?.status]}</p>
                            </div>
                        </div>
                        : null
            }

            <UncontrollableAccordion title="Comentários" show={step === 4} done={step > 4}>
                <PartnerCommentsStep setProductData={setProductData} setStep={setStep} productData={productData} />
            </UncontrollableAccordion>
        </main>
    )
}

export default CreatePartnerProduct;
